import { Chart, useChart } from '@chakra-ui/charts';
import { Card, Heading } from '@chakra-ui/react';
import { memo } from 'react';
import { Area, AreaChart, CartesianGrid, Legend, Tooltip, XAxis, YAxis } from 'recharts';

const SalesChart = () => {
  const chart = useChart({
    data: [
      { cUltra: 186, cMega: 80, cMax: 120, month: 'January' },
      { cUltra: 165, cMega: 95, cMax: 110, month: 'February' },
      { cUltra: 190, cMega: 87, cMax: 125, month: 'March' },
      { cUltra: 195, cMega: 88, cMax: 130, month: 'May' },
      { cUltra: 182, cMega: 98, cMax: 122, month: 'June' },
      { cUltra: 175, cMega: 90, cMax: 115, month: 'August' },
      { cUltra: 180, cMega: 86, cMax: 124, month: 'October' },
      { cUltra: 185, cMega: 91, cMax: 126, month: 'November' },
    ],
    series: [
      { name: 'cUltra', color: 'teal.solid', label: '40-slot charge station (CUltra)' },
      { name: 'cMega', color: 'purple.solid', label: '20-slot charge station (CMega)' },
      { name: 'cMax', color: 'blue.solid', label: '12-slot charge station (CMax)' },
    ],
  });

  return (
    <Card.Root w="full" h="full" bg="surface.background" borderColor="border.light">
      <Card.Header bg="sidebar.background" p={2}>
        <Heading size="sm">Total sales over time</Heading>
      </Card.Header>
      <Card.Body>
        <Chart.Root maxH="sm" chart={chart}>
          <AreaChart data={chart.data}>
            <CartesianGrid
              stroke={chart.color('border') as string}
              vertical={false}
              strokeDasharray="3 3"
            />
            <XAxis
              dataKey={chart.key('month')}
              tickLine={false}
              axisLine={false}
              tickMargin={8}
              tickFormatter={(value: string) => value.slice(0, 3)}
            />
            <YAxis tickLine={false} axisLine={false} />
            <Tooltip cursor={false} animationDuration={100} content={<Chart.Tooltip />} />
            <Legend content={<Chart.Legend />} />
            {chart.series.map((item) => (
              <defs key={item.name}>
                <Chart.Gradient
                  id={`${item.name}-gradient`}
                  stops={[
                    { offset: '0%', color: item.color, opacity: 0.3 },
                    { offset: '100%', color: item.color, opacity: 0.05 },
                  ]}
                />
              </defs>
            ))}
            {chart.series.map((item) => (
              <Area
                key={item.name}
                type="natural"
                isAnimationActive={false}
                dataKey={chart.key(item.name)}
                fill={`url(#${item.name}-gradient)`}
                stroke={chart.color(item.color) as string}
                strokeWidth={2}
                stackId="a"
              />
            ))}
          </AreaChart>
        </Chart.Root>
      </Card.Body>
    </Card.Root>
  );
};

export default memo(SalesChart);
